<template>
<div>  
    <div id="botlist" class="card shadow-sm">
        <loading :active.sync="scriptLoading" 
            :can-cancel="false" 
            :is-full-page="false"></loading>
        <div class="card-header">
            <h3>Process</h3>
        </div>
        <div class="card-body">
            <div id="file-drag-drop">
                <form ref="fileform">
                    <div class="file-dropbox shadow-sm rounded d-flex justify-content-center mb-2">
                        <!-- <span class="drop-files">Drop the files here!</span> -->
                        <!-- <p>Drag your file(s) here to begin<br> or click to browse</p> -->
                        <div class="align-self-center">
                            <h4><i class="fas fa-file-import"> Drop the files to create a new process</i> </h4>
                        </div>
                    </div>
                </form><br/>

                <div v-show="files.length <= 0">
                    <div style="display: inline-block; width: 50%">
                        <input ref="keyword" id="keyword" class="form-control" placeholder="keyword" name="keyword" v-model="keyword" v-bind:style="{width:'50%'}" style="float:left;" @input="searchScriptList">
                        <button type="button" class="btn btn-success flex-grow-0" style="margin-left:10px;">Search</button>
                        <label for="retrieveAllLabel" style="margin-left:20px;"> 전체&nbsp;<input type="radio" name="retrieveAll" value="all" v-model="retrieveType" v-on:change="selectRetrieveType($event)"/></label>
                        <label for="retrieveRecentLabel" style="margin-left:10px;"> 최신 버전&nbsp;<input type="radio" name="retreiveRecent" value="recent" v-model="retrieveType" v-on:change="selectRetrieveType($event)"/></label>
                    </div>
                    <div style="display: inline-block; float: right;">
                        <button type="button" class="btn btn-success mr-1" @click="runScriptModal()">Run Script</button>&nbsp;
                        <button type="button" class="btn btn-success mr-1" @click="retrieveChatbotProcessList()">Kakao Priority</button>
                    </div>
                </div>

                <div v-show="uploadPercentage > 0"> <!-- progress bar -->
                    <progress max="100" :value.prop="uploadPercentage"></progress>
                </div>

                <div v-show="files.length > 0" class="rounded script-block shadow-sm mb-4">
                    <div class="form-inline mb-2 pt-2">
                        <div class="input-group col-md-6" style="margin-bottom: 10px;">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Select Process</span>
                            </div>
                            <select v-model="existingScript" class="form-control" v-on:change="fillProcessInfo()">
                                <option value=""></option>
                                <option v-for="(script, index) in recentScriptList" v-bind:value="script.processName + versionParsingTxt + script.version">{{script.processName}} ( {{script.version}} )</option>
                            </select>
                        </div>

                        <div class="input-group col-md-6">
                        </div>

                        <div class="input-group col-md-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Process Name</span>
                            </div>
                            <input class="form-control" type="text" name="processName" v-model="processName"/>
                        </div>

                        <div class="input-group col-md-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Version</span>
                            </div>
                            <input class="form-control" type="text" name="version" placeholder='ex) 1.0.0' v-model="version"/>
                        </div>

                    </div> 
                    <div class="container">

                        <table class="table table-sm table-bordered">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center">Starting Point</th>
                                    <th>File Path</th>
                                    <th>File Name</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(file, key) in files" class="file-listing text-center">
                                    <td class="bg-light">
                                        <input type="radio" v-model="startingPoint" name="startingPoint" :value="key" :id="'file-' + key" v-show="isPeon(file.name)" />
                                        <b-tooltip :target="'file-' + key" triggers="hover" placement="left" variant ="info">
                                            Choose a starting point script!
                                        </b-tooltip>
                                    </td>
                                    <td class="bg-light"><input class="form-control" type="text" name="path" v-model="paths[key]"/></td>
                                    <td class="text-left bg-light">
                                        <i class="far fa-file-alt mr-1" v-bind:ref="'preview'+parseInt( key )">{{ file.name }}</i>
                                    </td>
                                    <td class="bg-light"><button type="button" class="btn btn-danger btn-sm" v-on:click="removeFile( key )" >Remove</button></td>
                                </tr>
                            </tbody>    
                        </table>
                    </div>
                    <div class="text-center pb-2">
                        <button type="button" class="btn btn-success" v-on:click="submitFiles()" >Submit</button>
                    </div>
                </div>
            </div> <!--file-drag-drop end -->

            <table class="table table-striped table-bordered table-hover shadow-sm mt-2" style="table-layout:fixed">
                <colgroup>
                    <col width="6%" />
                    <col width="26%" />
                    <col width="8%" />
                    <col width="36%" />
                    <col width="6%" />
                    <col width="9%" />
                    <col width="9%" />
                </colgroup>
                <thead class="script-header" >
                    <tr class="text-center">
                        <th></th>
                        <th>Process Name</th>
                        <th>Version</th>
                        <th colspan="2">Files</th>
                        <th></th>
                        <th>Update Date</th>
                        <!-- <th>Kakaotalk</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr class="filterScript" v-for="(script, index) in scriptList" v-if="script.latest !== retrieveExceptFlag">
                        <td class="text-center"><i style="font-size: 1.5em; color: DimGray;" class="fas fa-trash" type="button" v-on:click="deleteProcess(script.processName, script.version)"></i></td>
                        <td><a href="#" style="" @click="showDetails(script.processName, script.version)" class="process-detail" :class="fillOldVersionWithColor(script.latest)">{{ script.processName }}</a></td>
                        <td><span :class="fillOldVersionWithColor(script.latest)">{{ script.version }}</span></td>
                        <td style="text-overflow:ellipsis; overflow:hidden"><span v-html="showFiles(script.processName, script.version, script.files)" :class="fillOldVersionWithColor(script.latest)"></span></td>
                        <td><b-button style="font-weight:bold" v-if="script.files.length > 1" class="btn" @click="changeShowingMode(script.processName, script.version)">{{ expandMark(script.processName, script.version) }}</b-button></td>
                        <td class="text-center">
                           <!--  <button type="button" class="btn btn-success mr-1" @click="showRun(script.processName, script.version, index)">Run</button> -->
                            <button  type="button" class="btn btn-blue mr-1" @click="showDetails(script.processName, script.version)">Detail</button>
                        </td>
                        <td class="text-center" style="text-transform: uppercase;">
                            {{ (() => { 
                                const d = new Date(script.createDate); 
                                const yy = String(d.getFullYear()); 
                                const mm = String(d.getMonth() + 1).padStart(2, '0'); 
                                const dd = String(d.getDate()).padStart(2, '0'); 
                                const hh = String(d.getHours()).padStart(2, '0'); 
                                const mi = String(d.getMinutes()).padStart(2, '0'); 
                                const ss = String(d.getSeconds()).padStart(2, '0'); 
                                return `${yy}-${mm}-${dd} ${hh}:${mi}:${ss}`; 
                                })() }}

                        </td>
                        <!-- <td class="text-center" style="text-transform: uppercase;">
                            <span v-if="script.chatbotId.length > 0 && script.chatbotConnection == 'yes'">{{ script.chatbotActive == 'deactive' ? script.chatbotActive : 'active' }}</span>
                            <span v-else-if="script.chatbotId.length > 0 && script.chatbotConnection == 'no'">{{ script.chatbotConnection }}</span>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div> <!--card body end -->
    </div> <!--card end-->

    <!--Detail modal start-->
    <b-modal size="lg" ref="modalScriptRetention" header-class="detail-header" title="Process Details" ok-only ok-variant="secondary" ok-title="Close"> <!-- size = xl, lg, sm -->
        <loading :active.sync="detailPopupLoading" 
            :can-cancel="false" 
            :is-full-page="false"></loading>
        <div style="display: inline-block;" class="mb-2"> 
            <h5>{{ scriptRetentionTitle(popupProcessName, popupVersion) }}</h5>
        </div>        
        <div style="display: inline-block; float: right;" v-if="detailTabIndex == 0"> 
            <b-button variant="info" size="sm" v-on:click="retrieveScriptRetention(popupProcessName, popupVersion)">
            <i class="fas fa-sync-alt"></i> Refresh</b-button>
        </div>        
        <div style="display: inline-block; float: right;" v-else-if="detailTabIndex == 1"> 
            <b-button variant="info" size="sm" v-on:click="retrieveChatbotProcess(chatbotProcess)">
            <i class="fas fa-sync-alt"></i> Refresh</b-button>
        </div>
        <div class="row">
            <div class="col-12">
                
            </div>
        </div>
        <b-card no-body class="w-100">
            <b-tabs v-model="detailTabIndex" card active-nav-item-class="">
                <b-tab id="deviceDetailTab" title="Device">
                    <div style="display: inline-block; float: right;" class="mb-2"> 
                        <button v-if="checkLatestVersion(scriptRetentionInfo, scriptList, popupProcessName, popupVersion)" class="btn btn-danger btn-sm" v-on:click="updateAllDevice(popupProcessName, popupVersion)">Update to Lateast Version</button>
                    </div>
                    <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
                        <thead class="script-header" >
                            <tr class="text-center">
                                <th>Peon</th>
                                <!-- <th>Version</th> -->
                                <th>Status
                                    <!-- &nbsp;<b-button variant="info" size="sm" v-on:click="retrieveScriptRetention(popupProcessName, popupVersion)">
                                    <i class="fas fa-sync-alt"> Refresh</i></b-button> -->
                                </th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="script in scriptRetentionInfo">
                                <td>{{ script.deviceId }} ({{ script.alias }})</td>
                                <!-- <td>{{ script.version }}</td> -->
                                <td class="text-center">
                                    <button class="btn btn-sm" v-bind:style="{width:'75%'}"
                                        v-bind:class="downloadStatusClass(script)" 
                                        v-on:click="downloadScript(script)"
                                        :disabled="downloadStatusDisable(script)">
                                        {{ downloadStatusText(script) === 'Downloaded' ? 'Downloaded(' + script.version + ')' : downloadStatusText(script) }}                    
                                    </button>
                                </td>
                                <td class="text-center">
                                    <button v-if="downloadStatusText(script) === 'Downloaded'" class="btn btn-danger btn-sm" v-on:click="showRun(script.processName, script.version, script.deviceId)">Run</button>
                                    <button v-if="downloadStatusText(script) === 'Downloaded'" class="btn btn-danger btn-sm" style="margin-left:10px;" v-on:click="deactivateScript(script)">Deactivate</button>

                                    <button v-if="downloadStatusText(script) === 'Deactivated'" class="btn btn-danger btn-sm" v-on:click="activateScript(script)">Active</button>&nbsp;
                                    <button v-if="downloadStatusText(script) === 'Downloaded' || downloadStatusText(script) === 'Deactivated'" class="btn btn-danger btn-sm" v-on:click="deleteScript(script)">Delete</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-tab>
                <b-tab id="chatbotDetailTab" title="Chatbot" v-if="chatbotId">
                    <table class="table table-striped table-bordered table-hover shadow-sm">
                         <loading :active.sync="chatbotDetailLoading" 
                            :can-cancel="false" 
                            :is-full-page="false"></loading>
                            <!-- :loader="dots" 이거 왜 안되지? -->                
                       <thead class="script-header" >
                            <tr class="text-center">
                                <th>Item</th>
                                <th>Value</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>Kakao Bot ID</th>
                                <td><div class="form-group mr-2 flex-grow-1">
                                    <input readonly class="form-control" placeholder="kakao Bot ID" name="chatbotId" v-model="chatbotId" v-validate="'required|min:24|max:24'">
                                    <div class="alert-danger" v-if="submitted && errors.has('chatbotId')">{{ errors.first('chatbotId') }}</div>
                                </div></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th>Process State</th>
                                <td><div class="form-group mr-2 flex-grow-1">
                                    <label for="active" style=""> Active&nbsp;<input type="radio" name="active" value="active" v-model="chatbotActive"/></label>
                                    <label for="deactive" style="margin-left:20px;"> Deactive&nbsp;<input type="radio" name="deactive" value="deactive" v-model="chatbotActive"></label>
                                </div></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th>Inquiry</th>
                                <td><div class="form-group mr-2 flex-grow-1">
                                    <input class="form-control" placeholder="Inquiry" name="chatbotInquiry" v-model="chatbotInquiry" v-validate="'required'">
                                    <div class="alert-danger" v-if="submitted && errors.has('chatbotInquiry')">{{ errors.first('chatbotInquiry') }}</div>
                                </div></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th>Pre-Process</th>
                                <td><div class="form-group mr-2 flex-grow-1">
                                    <select class="form-control" v-model="chatbotPreProcess" v-validate="" name="chatbotPreProcess">
                                        <option value="">없음</option>
                                        <option v-for="(processName, index) in processNameList" :value="processName">{{processName}}</option>
                                    </select>
                                    <div class="alert-danger" v-if="submitted && errors.has('chatbotPreProcess')">{{ errors.first('chatbotPreProcess') }}</div>
                                </div></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th>Authority</th>
                                <td><div class="form-group mr-2 flex-grow-1">
                                    <select class="form-control" v-model="chatbotAuthorityName" v-validate="" name="chatbotAuthorityName">
                                        <option value="">없음</option>
                                        <option v-for="(authorityName, index) in authorityList" :value="authorityName">{{authorityName}}</option>
                                    </select>
                                    <div class="alert-danger" v-if="submitted && errors.has('chatbotAuthorityName')">{{ errors.first('chatbotAuthorityName') }}</div>
                                </div></td>
                            </tr>
                            <tr>
                                <th>Repetition</th>
                                <td><div class="form-group mr-2 flex-grow-1">
                                    <label for="yes" style=""> Yes&nbsp;<input type="radio" name="yes" value="yes" v-model="chatbotRepetition" :disabled="chatbotParams.length < 1"/></label>
                                    <label for="no" style="margin-left:20px;"> No&nbsp;<input type="radio" name="no" value="no" v-model="chatbotRepetition"></label>
                                </div></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th colspan="2">Parameter</th>
                                <td class="text-center">
                                    <i style="font-size: 2em; color: #52a7fe;" class="fas fa-plus-square" type="button" v-on:click="addChatbotParamRow"></i></td>
                            </tr>
                            <template  v-for="(item, index) in chatbotParams">
                                <tr><th><label>Name</label></th>
                                    <td><div class="form-group mr-2 flex-grow-1">
                                            <input class="form-control" placeholder="Parameter" name="paramName" v-model="item.paramName" v-validate="'required'">
                                            <div class="alert-danger" v-if="submitted && errors.has('paramName')">{{ errors.first('paramName') }}</div>
                                        </div>
                                    </td>                             
                                    <td colspan="4" class="text-center"><i style="font-size: 2em; color: grey;" class="fas fa-minus-square" type="button" v-on:click="removeChatbotParamRow(index)"></i>
                                    </td>
                                </tr>
                                <tr><td><label>Desc.</label></td>
                                    <td><div class="form-group mr-2 flex-grow-1">
                                            <input class="form-control" placeholder="Description" name="paramDesc" v-model="item.paramDesc">
                                            <div class="alert-danger" v-if="submitted && errors.has('paramDesc')">{{ errors.first('paramDesc') }}</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr><td><label>Options</label></td>
                                    <td><div class="form-group mr-2 flex-grow-1">
                                        <label style=""> Mandatory&nbsp;<input type="radio" :name="'mandatory'+index" value="yes" v-model="item.mandatory"/></label>
                                        <label style="margin-left:20px;"> Optional&nbsp;<input type="radio" :name="'mandatory'+index" value="no" v-model="item.mandatory"></label>
                                        </div>
                                    </td>
                                </tr>
                                <tr><td><label>Type</label></td>
                                    <td><div class="form-group mr-2 flex-grow-1">                                    
                                            <select class="form-control" v-model="item.paramType" v-validate="'required'" name="paramType">
                                                <option value="text" selected>Text</option>
                                                <option value="selectbox">Select Box</option>
                                            </select>
                                            <div class="alert-danger" v-if="submitted && errors.has('paramType')">{{ errors.first('paramType') }}</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr><td><label>Value</label></td>
                                    <td><div class="form-group mr-2 flex-grow-1">
                                            <input class="form-control" placeholder="Value" name="paramValue" v-model="item.paramValue">
                                            <div class="alert-danger" v-if="submitted && errors.has('paramValue')">{{ errors.first('paramValue') }}</div>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <div class="text-center pb-2" style="display: block; float: right;" >
                        <button type="button" class="btn btn-success" v-on:click="saveChatbotDetail()">{{ chatbotConnection == 'yes' ? 'Update' : 'Submit' }}</button>
                        <button v-show="chatbotConnection == 'yes'" type="button" class="btn btn-danger" style="margin-left: 10px;" v-on:click="deleteChatbotProcess(chatbotProcess)">Delete</button>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-modal>
    <!--Detail modal end -->

    <!--Chatbot Detail modal start-->
    <b-modal size="lg" ref="chatbotPriorityModal" header-class="detail-header" title="Chatbot Priority" ok-variant="primary" ok-title="Save" @ok="saveChatbotPriority"> <!-- size = xl, lg, sm -->
        <div class="mb-2">
            <h5 style="display: inline-block;"><i class="fas fa-mouse-pointer"> Drag and drop tho process box to change chatbot priority</i></h5>
            <div style="display: inline-block; float: right;">
                <b-button variant="info" size="sm" v-on:click="retrieveChatbotProcessList()">
                <i class="fas fa-sync-alt"></i> Refresh</b-button>                
            </div>
        </div>
        <div style="display: block;">
            <draggable class="list-group" tag="ul" v-model="chatbotProcessList" v-bind="dragOptions" @start="drag = true" @end="drag = false">
                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <li class="list-group-item" v-for="(item, index) in chatbotProcessList" :key="item.processName">
                        <span>{{ item.processName }} ({{ item.inquiry }})</span>
                        <!-- <span v-bind:style="[item.processName == chatbotProcess ? {'font-weight':'bold'} : {}]">{{ item.processName }} ({{ item.inquiry }})</span> -->
                    </li>
                </transition-group>
            </draggable>
        </div>
    </b-modal>

    <!-- 스크립트 실행을 위해 파라미터 받는 팝업 -->
    <b-modal id="arg_modal" size="sm" ref="modalScriptRun" :title="scriptRunTitle(popupRunProcessName, popupRunVersion)" @ok="scriptRun"> <!-- size = xl, lg, sm -->
        <label v-for="(item, index) in scriptArgs" v-bind:style="{width:'100%'}" >args[{{ index }}]<input class="form-control" type="text" name="item.name" v-model="item.args" v-bind:style="{width:'100%'}" ></label>
        <!-- </input> -->
        <button class="btn btn-danger btn-sm"  v-bind:style="{width:'100%'}" v-on:click="addArgs()">Args 추가</button>
    </b-modal>

    <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
        <p class="my-4 text-center">{{ msgContent }}</p>
    </b-modal>

    <!-- 스크립트 실행을 위해 파라미터 받는 팝업 (스크립트 선택 가능) -->
    <b-modal id="run_script_modal" ref="runScriptModal" title="Run Script" @ok="selectedScriptRun"> <!-- size = xl, lg, sm -->

        <label>스크립트 선택</label>
        <select  v-model="selectedScript" v-bind:style="{width:'100%'}" style="margin-bottom: 30px;">
            <option value="" disabled>Select</option>
            <option v-for="(script, index) in processList" v-bind:value="script.processName + versionParsingTxt + script.version">{{script.processName}} ( {{script.version}} )</option>
        </select>

        <label v-for="(item, index) in scriptArgs" v-bind:style="{width:'100%'}" >args[{{ index }}]<input class="form-control" type="text" name="item.name" v-model="item.args" v-bind:style="{width:'100%'}" ></label>
        <!-- </input> -->
        <button class="btn btn-danger btn-sm" v-bind:style="{width:'100%'}" v-on:click="addArgs()">Args 추가</button>
    </b-modal>
</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import draggable from 'vuedraggable'

export default {
    name: 'Scripts',
    components: {
        Loading,
        draggable,
    },
    data() {
        return {
            dragAndDropCapable: false,
            uploadPercentage: 0,
            files: [],
            paths: [],
            processName: '',  // TODO: processName을 새로 생성할 때도 사용하고, Popup으로 보여줄 때도 사용하고 있네..
            version: '',
            popupProcessName: '',
            popupVersion: '',
            popupRunProcessName: '',
            popupRunVersion: '',
            popupRunIndex: null,
            args0: '',
            args1: '',
            args2: '',
            scriptRetentionInfo: [],
            startingPoint: -1,
            showingMode: {},  // 프로세스의 files를 전체를 보여줄 것인지 starting point 만 보여줄 것인지, 값이 없으면 starting point만 보여줌

            scriptLoading: false,  // 전체 로딩바
            detailPopupLoading: false,  // 상세 팝업창 로딩바
            
            msgStatus: '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
            msgContent: '',
            keyword: '', // 검색키워드

            scriptArgs : [{name: '0', args: ''}],
            retrieveType: '',
            selectedScript: '',
            selectedDeviceId: '',
            versionParsingTxt: '_ver:',
            existingScript: '',
            retrieveExceptFlag: null,

            chatbotDetailLoading : false,
            detailTabIndex : 0,
            // chatbotOptions : [
            //     { value: 'yes', text: 'Yes' },
            //     { value: 'no', text: 'No' }
            // ],
            chatbotParams : [
                {paramName: '', paramDesc: '', paramType: '', paramValue: '', mandatory: 'yes'}
            ],
            chatbotConnection : 'no',
            chatbotProcess : '',
            chatbotInquiry : '',
            chatbotPreProcess : '',
            chatbotAuthorityName : '',

            chatbotRepetition : 'no',
            chatbotParam : '',
            chatbotId : '',
            chatbotActiveOptions : [
                { value: 'active', text: 'Active' },
                { value: 'deactive', text: 'Deactive' }
            ],
            chatbotActive : 'deactive',
            chatbotPriority : 1,
            chatbotProcessList : [],
            drag: false,
            submitted : '',

            scriptList: [],
            recentScriptList: [],
            processNameList: [],
            processList: [],

            authorityList: []
        }
    },
    computed: {
        dragOptions() {
          return {
            animation: 200,
            group: "description",
            disabled: false,
            ghostClass: "ghost"
          };
        }
    },
    methods: {
        deleteChatbotProcess(processName) {
            this.$bvModal.msgBoxConfirm('챗봇연결을 해제하시겠습니까?', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'YES',
                cancelTitle: 'NO',
                headerClass: 'detail-header',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true

            }).then(async value => {
                let params = {
                    'processName': processName
                };

                this.loading = true;

                if(value) {
                    await axios.get('peon/deleteKakaoProcess', {
                        params: params,
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': window.accessToken()
                        }
                    }).catch(response => {
                        // An error occurred
                        this.msgStatus = response.status;
                        this.msgContent = response.message;
                        
                        this.$bvModal.show('messageModal');

                    }).finally(() => {
                        this.retrieveChatbotProcess(processName);
                        this.retrieveScriptList();
                        this.loading = false;
                    });
                } else {
                    this.retrieveChatbotProcess(processName);
                    this.retrieveScriptList();
                    this.loading = false;
                }
            });
        },
        async retrieveChatbotProcess(processName) {
            var params = {
                'processName': processName
            };

            await axios.get('peon/retrieveKakaoProcess', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }

            }).then(response => {
                // 챗봇 프로세스 기본정보
                this.chatbotProcess = processName;
                this.chatbotId = response.data.body.kakaoBotId;
                this.chatbotInquiry = response.data.body.inquiry;
                this.chatbotPreProcess = response.data.body.preProcess ? response.data.body.preProcess : '';
                this.chatbotAuthorityName = response.data.body.authorityName ? response.data.body.authorityName : '';


                this.chatbotRepetition = response.data.body.repetition == true ? 'yes' : 'no';
                this.chatbotActive = response.data.body.active == 'deactive' ? 'deactive' : 'active';
                this.chatbotConnection = response.data.body.kakaoConnection;

                // 챗봇 프로세스 추가정보
                let chatbotParamsData = [];
                response.data.body.kakaoParams.forEach(function(item, index, array) {
                    chatbotParamsData.push({
                        'paramName': item.parameter,
                        'paramDesc': item.description,
                        'paramType': item.type,
                        'paramValue': item.value,
                        'mandatory': (item.mandatory == true ? 'yes' : 'no')            
                    });
                });

                if(chatbotParamsData) {
                    this.chatbotParams = chatbotParamsData;
                }           

                // 챗봇 우선순위 정보
                let chatbotPriorityList = [];
                response.data.body.kakaoProcessList.forEach(function(item, index, array) {
                    chatbotPriorityList.push(item.priority);
                });

                this.chatbotPriority = chatbotPriorityList ? chatbotPriorityList.sort().reverse()[0] + 1 : 1;

            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }

            }).finally(() => {
            });
        },
        async retrieveChatbotProcessList() {
            var params = {
            };

            await axios.get('peon/retrieveKakaoProcessList', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }

            }).then(response => {
                let chatbotProcessListData = [];
                response.data.body.kakaoProcessList.forEach(function(item, index, array) {
                    chatbotProcessListData.push({
                        'processName': item.processName,
                        'priority': item.priority,
                        'inquiry' : item.inquiry
                    });
                });

                this.chatbotProcessList = chatbotProcessListData;

            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }

            }).finally(() => {
                this.$refs['chatbotPriorityModal'].show();
            });
        },
        addChatbotParamRow() {
            this.chatbotParams.push({paramName: '', paramDesc: '', paramType: 'text', paramValue: '', mandatory: 'yes'});
        },
        removeChatbotParamRow: function(index) {
            this.chatbotParams.splice(index, 1);

            if(this.chatbotParams.length < 1) {
                this.chatbotRepetition = 'no';
            }
        },
        async saveChatbotDetail() {
            if(this.chatbotProcess.length <= 0 || this.chatbotProcess === null) {
                this.showMessage(0, "프로세스를 찾을 수 없습니다.");
                return;
            }

            if(this.chatbotParams.length < 1 && this.repetition === 'yes') {
                this.showMessage(0, "Parameter가 없는 프로세스는 반복여부를 'Yes'로 선택할 수 없습니다.");
                this.repetition = 'no';
                return;
            }            

            // 챗봇 연결정보 저장
            if(this.detailTabIndex == 1) {
                this.submitted = true;

                this.$validator.validate().then(async valid => {
                    if (valid) {
                        let params = {
                            'processName': this.chatbotProcess,
                            'inquiry' : this.chatbotInquiry,
                            'preProcess' : this.chatbotPreProcess,
                            'authorityName' : this.chatbotAuthorityName,
                            'kakaoBotId' : this.chatbotId,
                            'active' : this.chatbotActive == 'deactive' ? 'deactive' : null,             
                            'repetition' : this.chatbotRepetition == 'yes' ? true : false,             
                            'priority' : this.chatbotPriority,
                        };

                        let chatbotParamsData = [];
                        this.chatbotParams.forEach((item, index) => {
                            if (item.paramName != null && item.paramName.trim().length > 0) {
                                chatbotParamsData.push({
                                    'parameter' : item.paramName.trim(),
                                    'description' : item.paramDesc.trim(),
                                    'type': item.paramType.trim(),
                                    'value' : item.paramValue.trim(),
                                    'mandatory': item.mandatory == 'yes' ? true : false
                                });
                            }                
                        });

                        if (chatbotParamsData.length > 0) {
                            params.kakaoParams = chatbotParamsData;
                        }

                        this.chatbotDetailLoading = true;

                        await axios.post('peon/updateKakaoProcess', params, {
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': accessToken()
                            }

                        }).then(response => {
                            this.showMessage(0, "Completed");
                        }).catch(error => {
                            if (error.status != 401) {
                                this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                            }

                        }).finally(() => { 
                            this.retrieveChatbotProcess(this.chatbotProcess);                  
                            this.chatbotDetailLoading = false;                   
                            this.submitted = false;
                            this.retrieveScriptList();       
                        });
                    }
                });
            }
        },
        async saveChatbotPriority(evt) {
            evt.preventDefault();

            var params = {};
            var chatbotProcessListData = [];

            this.chatbotProcessList.forEach((item, index) => {
                if (item.processName != null && item.processName.trim().length > 0 && item.priority != (index + 1)) {
                    chatbotProcessListData.push({'processName' : item.processName.trim(), 'priority' : (index + 1)});
                }                
            });

            if (chatbotProcessListData.length > 0) {
                params.kakaoProcessList = chatbotProcessListData;
            } else {
                return;
            }

            this.chatbotDetailLoading = true;

            await axios.post('peon/updateKakaoProcessPriority', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }

            }).then(response => {
                this.showMessage(0, "Completed");

            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }

            }).finally(() => {
                this.chatbotDetailLoading = false;
                this.retrieveChatbotProcessList();
            });
        },
        deactivateChatbot(processName) {
            if(processName.length <= 0 || processName === null) {
                this.showMessage(0, "'프로세스를 찾을 수 없습니다.");
                return;
            }

            var params = {
                'processName': processName,
                'active': "deactive"
            };

            this.chatbotDetailLoading = true;
            
            axios.get('peon/updateKakaoProcessActive', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': window.accessToken()
                }
            }).then(response => {

            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }

            }).finally(() => {
                this.chatbotDetailLoading = false;
            });
        },
        addArgs : function() {
            this.scriptArgs.push({tableName: this.scriptArgs.length, args: ''});
        },
        fillProcessInfo : function() {
            this.processName = this.existingScript.split(this.versionParsingTxt)[0];

            // process 존재 유무 확인
            var scriptNameList = [];
            for (var script of this.recentScriptList) {
                scriptNameList.push(script.processName);
            }
        
            if(scriptNameList.indexOf(this.processName) == -1) {
                this.version = '';
                return;
            }

            // version validation        
            if(!this.versionValidation(this.existingScript.split(this.versionParsingTxt)[1])) {
                return;
            }

            const tempVer = this.existingScript.split(this.versionParsingTxt)[1];
            this.version = this.updateVersion(tempVer);
        },
        versionValidation(version) {
            let pattern = /^([1-9]{0,1})([0-9]{0,1}).?([0-9]{1}).?([0-9]{1})$/;
            if(!pattern.test(version)) {
                return false;
            }
            return true;
        },
        updateVersion(version) {
            const arr = version.split('.');

            let major = Number(arr[0]);
            let minor = Number(arr[1]);
            let trivial = Number(arr[2]);

            trivial = trivial + 1;

            if(trivial > 9) {
                trivial = 0;
                minor = minor + 1;
            }

            if(minor > 9) {
                minor = 0;
                major = major + 1;
            }

            return major + '.' + minor + '.' + trivial;

        },
        searchScriptList(e) {
            let pattern = /([^가-힣A-Za-z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"\x20])/i;

            if(pattern.test(e.target.value)) {
                return;
            }

            clearTimeout(this.debounce);          

            this.debounce = setTimeout(() => {
                this.retrieveScriptList(this.retrieveType, e.target.value);
            }, 500);
        },
        async retrieveScriptList(type, keyword) {
            var params = {
                'keyword': keyword
            };

            // this.scriptLoading = true;
            var that = this;

            await axios.get('peon/retrieveScriptList', {
                params : params,
                headers : {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                if (keyword != that.$refs.keyword.value) {
                    this.retrieveScriptList(this.retrieveType, that.$refs.keyword.value);
                }

                response.data.body.list.forEach((item, index) => {
                    item.latest = false;

                    const filteredList = response.data.body.list.filter(compare => compare.processName === item.processName);

                    if(filteredList.length > 0) {
                        const max = filteredList.reduce((p, c) => p.version > c.version ? p : c);
                        max.latest = true;
                    } else {
                        item.latest = true;
                    }
                })

                this.scriptList = response.data.body.list;
                this.recentScriptList = this.$store.state.recentScriptList;
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                // this.scriptLoading = false;
            });
        },
        retrieveScriptListAll() {

        },
        showMessage(status, message) {
            this.msgStatus = status;
            this.msgContent = message;
            
            this.$bvModal.show('messageModal');
        },
        isPeon(file) {
            if (file == null) {
                return false;
            }

            if (file.endsWith('.peon')) {
                return true;
            }

            return false;
        },
        runScriptModal() {
            this.selectedScript = '';
            this.scriptArgs = [{tableName: '0', args: ''}];

            // processList(run script modal script select box values
            var that = this;
            this.processList = [];

            this.$store.state.scriptList.forEach(function(item, index) {
                that.processList.push(item);
            })

            this.$refs['runScriptModal'].show();
        },
        selectedScriptRun(bvModalEvt) {            
            //script 유효성 검사
            if(this.selectedScript.length <= 0 || this.selectedScript === null) {
                //this.$refs['runScriptModal'].close();
                this.showMessage(0, "Please Select Script to Run");
                return;
            }

            var params = {
                'command': 'run', 
                'processName': this.selectedScript.split(this.versionParsingTxt)[0],
                'version': this.selectedScript.split(this.versionParsingTxt)[1],
            };

            var args = [];
            this.scriptArgs.forEach((item, index) => {

                if (item.args != null && item.args.trim().length > 0) {
                    args.push(item.args.trim());
                }
                
            });

            if (args.length > 0) {
                params.args = args;
            }

            this.scriptLoading = true;

            axios.post('peon/command', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.scriptArgs = [{tableName: '0', args: ''}];

            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.scriptLoading = false;
            });
        },
        showRun(processName, version, deviceId) {
            this.scriptArgs = [{tableName: '0', args: ''}];

            this.popupRunProcessName = processName;
            this.popupRunVersion = version;
            this.selectedDeviceId = deviceId;

            this.$refs['modalScriptRun'].show();
        },
        scriptRun(bvModalEvt) {
            var params = {
                'command': 'run', 
                'deviceId': this.selectedDeviceId,
                'processName': this.popupRunProcessName,
                'version': this.popupRunVersion,
            };

            var args = [];
            this.scriptArgs.forEach((item, index) => {

                if (item.args != null && item.args.trim().length > 0) {
                    args.push(item.args.trim());
                }
                
            });


            if (args.length > 0) {
                params.args = args;
            }

            this.scriptLoading = true;

            axios.post('peon/command', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.scriptArgs = [{tableName: '0', args: ''}];

            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.scriptLoading = false;
            });
        },
        showDetails(processName, version) {
            this.detailTabIndex = 0;
            this.popupProcessName = processName;
            this.popupVersion = version;

            this.retrieveScriptRetention(processName, version);
            this.retrieveChatbotProcess(processName);

            // processNameList(chatbot tab pre-process select box values)
            var that = this;
            this.processNameList = [];
            this.authorityList = [];

            this.$store.state.scriptList.forEach(function(item, index) {
                that.processNameList.push(item.processName);
            })

            this.processNameList = Array.from(new Set(this.processNameList));

            //20221104 authorityList 추출
            this.$store.dispatch('retrieveKakaoAuthorityList').then(() => {
                //that.allAuthorities = [];
                
                that.$store.getters.getAuthorityList.forEach((item, index, array) => {
                    that.authorityList.push(item.authorityName);
                });
                this.authorityList = Array.from(new Set(this.authorityList));
            });

            //20221104 추가
            // that.$store.getters.getAuthorityList.forEach((item, index, array) => {
            //     that.authorityList.push(item.authorityName);
            // });

            
            this.$refs['modalScriptRetention'].show();
        },
        retrieveScriptRetention(processName, version) {
            this.detalPopupLoading = true;

            var params = {
                'processName': processName,
                'version': version
            };

            axios.get('peon/retrieveScriptRetention', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.scriptRetentionInfo = response.data.body.list;
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.detailPopupLoading = false;
            });
        },
        scriptRetentionTitle(processName, version) {
            return processName + " (" + version + ")";
        },
        scriptRunTitle(processName, version) {
            return processName + " (" + version + ")";
        },
        downloadStatusDisable(device) {
            if (device.alive == 1) {
                if (device.processName === null) {
                    return false;
                }

                return true;
            }

            return true;
        },
        fillOldVersionWithColor(flag) {
            if(flag !== true) {
                return "text-color-gray";   //TODO : 회색으로
            }

            return "";

        },
        downloadStatusClass(device) {
            if (device.alive == 1) {
                if (device.processName === null) {
                    return "btn-green";
                }

                return "btn-red";
            }

            return "btn-gray";
        },
        downloadStatusText(device) {
            if (device.alive == 1) {
                if (device.processName === null) {
                    return "Download";
                } else if (device.active != null && device.active != 'active') {
                    return "Deactivated";
                }
                return "Downloaded";
            } else if (device.alive == 2) {
                return "Running";
            } else if (device.alive == 0) {
                return "Dead";
            } else {
                return "Unknown";
            }
        },
        checkLatestVersion(scriptInfoList, scriptList, popupProcessName, popupVersion) {
            //해당 프로세스의 최신 버전 가져오기
            if(scriptList === null || scriptList.length === 0) {
                return false;
            }

            //최신버전이 아닌 bot이 있는지 체크하여 true return
            if(scriptInfoList === null || scriptInfoList.length === 0) {
                return false;
            }

            const filtered = scriptList.filter(item => item.processName === popupProcessName && item.latest === true);

            if(!filtered) {
                // TODO 에러처리
                alert("error function checkLatestVersion : " + popupProcessName);

            }

            const latestVer = filtered[0] ? filtered[0].version : '0.0.0';

            for(var i=0; i<scriptInfoList.length; i++) {
                if(scriptInfoList[i].processName === popupProcessName && scriptInfoList[i].version !== null && scriptInfoList[i].version !== latestVer) {
                    return true;
                }
            }

            return false;

        },
        updateAllDevice(popupProcessName, popupVersion) {
            //processName 이 같은데 version이 낮은 애들을 업데이트
            //alive 상태면 바로 업데이트
            //dead 상태면 DB에 저장 후 살아나면 자동 업데이트

            //processName, version null 체크
            if(popupProcessName === null || popupVersion === "") {
                this.showMessage(-1, "process name or version cannot be null");
                return;
            }

            var params = {
                'processName': popupProcessName,
                'version': popupVersion,
            };

            this.scriptLoading = true;

            axios.post('peon/updateScriptVersion', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.showMessage(0, "최신 버전으로 업데이트 완료되었습니다.");
                this.retrieveScriptRetention(this.popupProcessName, this.popupVersion);
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.scriptLoading = false;
            });

        },
        // deleteProcess는 전체 프로세스를 지우는 것, 아래 deleteScript는 peon에게 다운로드 받은 스크립트를 지우라고 하는 것
        async deleteProcess(processName, version) {
            this.$bvModal.msgBoxConfirm('삭제하시겠습니까?', {
                title: 'Confirm'
            })
            .then(value => {            
                if(value) {
                    var params = {
                        'processName': processName,
                        'version': version
                    };

                    this.scriptLoading = true;

                    axios.get('peon/deleteScript', {
                        params: params,
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': accessToken()
                        }
                    }).then(response => {
                        this.showMessage(0, processName + '(' + version + ') 삭제 했습니다.');
                        this.$store.dispatch('retrieveScriptList');
                        this.$store.dispatch('recentScriptList');
                        this.retrieveScriptList();

                    }).catch(error => {
                        if (error.status != 401) {
                            this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                        }
                    }).finally(() => {
                        this.scriptLoading = false;
                    });

                }

            })
            .catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            })

        },
        downloadScript(device) {
            this.detalPopupLoading = true;

            axios.post('/peon/command', {'command': 'downloadScript', 'deviceId': device.deviceId, 'processName': this.popupProcessName, 'version': this.popupVersion}, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.showMessage(0, "File download success!!");
                this.retrieveScriptRetention(this.popupProcessName, this.popupVersion);
            }).catch(error =>  {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.detalPopupLoading = false;
            });
                   
        },
        // deleteScript는 Peon에 있는 프로세스를 지우는 것
        deleteScript(device) {
            this.detalPopupLoading = true;

            axios.post('/peon/command', {'command': 'deleteScript', 'deviceId': device.deviceId, 'processName': this.popupProcessName, 'version': this.popupVersion}, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.showMessage(0, "File delete success!!");
                this.retrieveScriptRetention(this.popupProcessName, this.popupVersion)
            }).catch(error =>  {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.detalPopupLoading = false;
            });        
        },
        deactivateScript(device) {
            var params = {
                'deviceId' : device.deviceId,
                'processName': this.popupProcessName,
                'version': this.popupVersion
            };

            this.scriptLoading = true;

            axios.get('peon/deactivateScript', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.showMessage(0, this.popupProcessName + '(' + this.popupVersion + ') 비활성화되었습니다.');
                this.retrieveScriptRetention(this.popupProcessName, this.popupVersion)
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.scriptLoading = false;
            });
        },
        activateScript(device) {
            var params = {
                'deviceId' : device.deviceId,
                'processName': this.popupProcessName,
                'version': this.popupVersion
            };

            this.scriptLoading = true;

            axios.get('peon/activateScript', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.showMessage(0, this.popupProcessName + '(' + this.popupVersion + ') 활성화되었습니다.');
                this.retrieveScriptRetention(this.popupProcessName, this.popupVersion)
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.scriptLoading = false;
            });
        },
        showFiles(processName, version, files) {
            if (this.showingMode[processName + " " + version] === "expand") {
                var f = "";
                files.forEach(function(item, index, array) {
                    f += (item.startingPoint == true ? "* " : ' ') + item.path + (item.path === '/' ? '' : '/') + item.file + "<br />";
                });

                return f;
            } else {
                var f = "";
                files.forEach(function(item, index, array) {
                    if (item.startingPoint == true) {
                        f = (item.startingPoint == true ? "* " : ' ') + item.path + (item.path === '/' ? '' : '/') + item.file + "<br />";
                    }
                });

                return f;
            }
        },
        changeShowingMode(processName, version) {
            if (this.showingMode[processName + " " + version] === "expand") {
                this.$set(this.showingMode, processName + " " + version, "collapse");
                // this.showingMode[processName + " " + version] = "collapse";
            } else {
                // this.showingMode[processName + " " + version] = "expand";
                this.$set(this.showingMode, processName + " " + version, "expand");
            }
        },
        expandMark(processName, version) {
            if (this.showingMode[processName + " " + version] === "expand") {
                return " -";
            } else {
                return "+";
            }
        },
        /*
        Determines if the drag and drop functionality is in the
        window
        */
        determineDragAndDropCapable() {
            /*
              Create a test element to see if certain events
              are present that let us do drag and drop.
            */
            var div = document.createElement('div');

            /*
              Check to see if the `draggable` event is in the element
              or the `ondragstart` and `ondrop` events are in the element. If
              they are, then we have what we need for dragging and dropping files.

              We also check to see if the window has `FormData` and `FileReader` objects
              present so we can do our AJAX uploading
            */
            return ( ( 'draggable' in div )
                    || ( 'ondragstart' in div && 'ondrop' in div ) )
                && 'FormData' in window
                && 'FileReader' in window;
        },

        /*
        Gets the image preview for the file.
        */
        getImagePreviews() {
            /*
            Iterate over all of the files and generate an image preview for each one.
            */
            for( let i = 0; i < this.files.length; i++ ) {
                /*
                Ensure the file is an image file
                */
                if ( /\.(jpe?g|png|gif)$/i.test( this.files[i].name ) ) {
                    /*
                    Create a new FileReader object
                    */
                    let reader = new FileReader();

                    /*
                    Add an event listener for when the file has been loaded
                    to update the src on the file preview.
                    */
                    reader.addEventListener("load", function(){
                        this.$refs['preview'+parseInt( i )][0].src = reader.result;
                    }.bind(this), false);

                    /*
                    Read the data for the file in through the reader. When it has
                    been loaded, we listen to the event propagated and set the image
                    src to what was loaded from the reader.
                    */
                    reader.readAsDataURL( this.files[i] );
                } else {
                    /*
                    We do the next tick so the reference is bound and we can access it.
                    */
                    this.$nextTick(function(){
                        this.$refs['preview'+parseInt( i )][0].src = '/images/file.png';
                    });
                }
            }
        },
        /*
        Submits the files to the server
        */
        submitFiles() {
            if (this.processName == null || this.processName.trim() === '') {
                this.showMessage(-1, "Process Name은 필수입니다.");
                return;
            }

            if (this.version == null || this.version.trim() === '') {
                this.showMessage(-1, "Version은 필수입니다.");
                return;
            }

            if(!this.versionValidation(this.version)) {
                this.showMessage(-1, "Version은 정수 major.minor.trivial(x.x.x)의 형태로 입력해주세요.");
                return;
            }

            if (this.startingPoint < 0 || this.startingPoint >= this.files.length) {
                // starting point를 지정하지 않았더라도, 딱 1개의 peon 파일만 등록하는 경우라면 그냥 허용해줌
                if (this.files.length == 1 && this.files[0].name.endsWith('.peon')) {
                    this.startingPoint = 0;
                } else {
                    this.showMessage(-1, "이 프로세스의 시작점(peon) 지정은 필수입니다.");    
                    return;
                }
            }

            /*
            Initialize the form data
            */
            let formData = new FormData();

            /*
            Iteate over any file sent over appending the files
            to the form data.
            */
            for(var i = 0; i < this.files.length; i++) {
                // 파일명에 확장자 필수
                let name = this.files[i].name;
                if(name.indexOf('.') == -1 || name.startsWith('.') || name.endsWith('.')) {
                    this.showMessage(-1, name + " extension not found");
                    return;
                }

                formData.append('file[' + i + ']', this.files[i]);

                let path = this.paths[i] == null ? '/' : this.paths[i].trim();
                path = path.replace(/\\/g, '/');
                path = path.replace(/\/\//g, '/');

                //경로표기 혹은 폴더명에 하기 특수문자 입력 불가능
                if(/[?:*<>\"]/gi.test(path)) {
                    this.showMessage(-1, "File path cannot write '*:?<>" + '"' + "'");
                    return;
                }


                //상대 경로 - 현재 폴더 기준으로 입력할 경우, 정상적으로 입력했다고 판단하여 루트로 formatting
                if(path.startsWith('./')) {
                    path = path.substring(2, path.length);
                }

                //'/./', '/../', './../' 등 잘못된 format validation
                if(path.startsWith('/')) {
                    let vaildPath = path.substring(1, path.length)

                    if(vaildPath.startsWith('./') || vaildPath.startsWith('../')) {
                        this.showMessage(-1, "File path cannot start with wrong format");
                        return;
                    }
                }

                //peon 기본 업로드 폴더를 루트로 하여, 그 상위루트를 선택할 수 없음
                if(path.startsWith('../')) {
                    this.showMessage(-1, "File path cannot start with '../'");
                    return;
                }

                //default formatting
                if (path.endsWith('/')) {
                    path = path.substring(0, path.length - 1);
                }

                if (path.startsWith('/') == false) {
                    path = '/' + path;
                }

                //확인용 last validation (모든 validation을 통과한 경로라면 폴더 혹은 경로표기에 . 가 포함될 수 없음)
                if(path.indexOf('.') > -1) {
                    this.showMessage(-1, "File path cannot start with wrong format");
                    return;
                }

                formData.append('path[' + i + ']', path);

                // formData.append('file[' + i + ']', this.files[i]);

                // let path = this.paths[i] == null ? '/' : this.paths[i].trim();
                // path = path.replace(/\\/g, '/');

                // if (path.endsWith('/')) {
                //     path = path.substring(0, path.length - 1);
                // }

                // if (path.startsWith('/') == false) {
                //     path = '/' + path;
                // }

                // formData.append('path[' + i + ']', path);
            }

            formData.set('processName', this.processName);
            formData.set('version', this.version);
            formData.set('startingPoint', this.startingPoint);

            var that = this;
            /*
            Make the request to the POST /file-drag-drop URL
            */
            axios.post('/peon/uploadScript', formData, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'multipart/form-data',
                    'Authorization': accessToken()
                },

                onUploadProgress: function( progressEvent ) {
                    that.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
                }
            }).then(response => {
                this.showMessage(0, "File upload success!!");

                this.files = [];
                this.paths = [];
                this.processName = '';
                this.version = '';
                this.startingPoint = -1;
                this.existingScript = '';

                this.$store.dispatch('retrieveScriptList');
                this.$store.dispatch('recentScriptList');
                this.retrieveScriptList();
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(function() {
                this.uploadPercentage = 0;
            }.bind(this));
        },
        /*
        Removes a select file the user has uploaded
        */
        removeFile(key) {
            this.files.splice(key, 1);
            this.paths.splice(key, 1);

            if(key < this.startingPoint) {
                this.startingPoint = this.startingPoint - 1;
            } else if(key == this.startingPoint) {                
                this.startingPoint = -1;
            }
        },

        /*
        filter script list
        */
        async selectRetrieveType(event) {
            var type = '';
            type = typeof event === 'object' ? event.target.value : event;

            // this.scriptLoading = true;
            // await this.retrieveScriptList(type);
            // this.scriptLoading = false;

            this.retrieveExceptFlag = null;
            if(type === 'recent') {
                this.retrieveExceptFlag = false;
            }
        }
    },
    created() {        
        this.retrieveScriptList();
    },
    mounted() {
        /*
        Determine if drag and drop functionality is capable in the browser
        */
        this.dragAndDropCapable = this.determineDragAndDropCapable();

        /*
        If drag and drop capable, then we continue to bind events to our elements.
        */
        if( this.dragAndDropCapable ){
            /*
            Listen to all of the drag events and bind an event listener to each
            for the fileform.
            */
            ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
                /*
                For each event add an event listener that prevents the default action
                (opening the file in the browser) and stop the propagation of the event (so
                no other elements open the file in the browser)
                */
                this.$refs.fileform.addEventListener(evt, function(e){
                    e.preventDefault();
                    e.stopPropagation();
                }.bind(this), false);
            }.bind(this));

            /*
            Add an event listener for drop to the form
            */
            this.$refs.fileform.addEventListener('drop', function(e) {
                /*
                Capture the files from the drop event and add them to our local files
                array.
                */
                for(let i = 0; i < e.dataTransfer.files.length; i++) {
                    this.files.push( e.dataTransfer.files[i] );
                    // this.getImagePreviews();  // 굳이 이미지 파일이라고 해서 뭘 보여주고 할 필요 없음
                    for( let i = 0; i < this.files.length; i++ ){
                        this.$nextTick(function(){
                            this.$refs['preview'+parseInt( i )][0].src = '../../src/assets/images/file.png';
                        });
                    }
                }

                // Starting Point
                let startingPointIdx = [];

                for(let i = 0; i < this.files.length; i++) {
                    if(this.files[i].name.endsWith('.peon')) {
                        startingPointIdx.push(i);
                    }
                }

                if(startingPointIdx.length == 1) {
                    this.startingPoint = startingPointIdx[0];
                }

                // file 처음 추가하는 경우 existingScript 초기화
                if(this.files.length == 1) {
                    this.paths = [];
                    this.processName = '';
                    this.version = '';
                    this.existingScript = '';                    
                }

            }.bind(this));
        }

        /*
        retrieve all script with each version when the page is loaded
        */
        this.retrieveType = 'all';
        this.selectRetrieveType(this.retrieveType);

        this.selectedScript = '';
        this.scriptArgs = [{tableName: '0', args: ''}];
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
progress {
    width: 400px;
    margin: auto;
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
}

.file-listing {
    padding: 0.4rem;
    border-bottom: 1px solid #ddd;
}

.process-detail {
    text-decoration: none;
    color: black;
}

.text-color-gray {
    color : #bababa;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
  background: #F5F5F5;
}
.list-group-item i {
  cursor: pointer;
}
</style>
